import { accentColorConfig } from '@hooks/useAccentColor'
import { AccentColor } from '@typings/index'
import { Check } from 'lucide-react'

interface ColorPickerProps {
  value: AccentColor
  onChange: (color: AccentColor) => void
}

const ColorPicker = ({ value, onChange }: ColorPickerProps) => {
  const colors: { value: AccentColor; label: string }[] = [
    { value: 'lightBlue', label: 'Light Bleu' },
    { value: 'navyBlue', label: 'Violet' },
    { value: 'green', label: 'Vert' },
    { value: 'yellow', label: 'Rose' },
    { value: 'limeGreen', label: 'Ambre' },
  ]

  return (
    <div className="flex flex-wrap gap-2">
      {colors.map((color) => (
        <button
          key={color.value}
          onClick={() => onChange(color.value)}
          className={`w-8 h-8 rounded-full flex items-center justify-center ${
            accentColorConfig[color.value].primary
          } transition-transform ${value === color.value ? 'scale-110 ring-2 ring-offset-2 ring-gray-300' : ''}`}
          title={color.label}
        >
          {value === color.value && <Check className="w-4 h-4 text-white" />}
        </button>
      ))}
    </div>
  )
}

export default ColorPicker
